import { put, call, takeLatest, takeEvery, all } from 'redux-saga/effects';
import * as types from '../projects/actionTypes.projects';
import * as errorSaga from '../errors/saga.errors';
import * as _ from 'lodash';
import Api from '../../api/Api';
import { IPromiseParam } from '../base';

export function* watch() {
    yield takeEvery(types.GET_BTN_OPTIONS_REQ, getButtonOptions);
    yield takeEvery(types.ADD_BTN_OPTIONS_REQ, addButtonOptions);
    yield takeEvery(types.UPDATE_BTN_OPTIONS_REQ, updateButtonOptions);
    yield takeEvery(types.DELETE_BTN_OPTIONS_REQ, deleteButtonOptions);
}

interface GetButtonOptionsParam extends IPromiseParam {
    projectId: string;
}

export function* getButtonOptions({ projectId, resolve, reject }: GetButtonOptionsParam) {
    try {
        let savedOptions = yield call(Api.getButtonOptions, projectId);

        savedOptions = savedOptions?.map(opt => ({ ...opt, updateTs: +opt.updateTs }));
        savedOptions = _.sortBy(savedOptions, 'updateTs').reverse();
      
        yield put({ type: types.GET_BTN_OPTIONS_OK, savedOptions });

        if (resolve) {
            resolve(savedOptions);
        }

        return savedOptions;
    } catch (error) {
        if (reject) {
            reject();
        }
        yield errorSaga.putError(error);
    }
}

interface IAddButtonOptionsParam extends IPromiseParam {
    projectId: string;
    name: string;
    options: any;
}


export function* addButtonOptions({ projectId, name, options, resolve, reject }: IAddButtonOptionsParam) {
    try {
        const savedOption = yield call(Api.createButtonOptions, projectId, name, options);
        const updatedOptions = yield getButtonOptions({ projectId });
        resolve({
            current: savedOption,
            options: updatedOptions
        });
    } catch (error) {
        yield errorSaga.putError(error);
    }
}


interface IUpdateButtonOptionsParam extends IPromiseParam {
    projectId: string;
    name: string;
    id: string;
    options: any;
}

export function* updateButtonOptions({ projectId, id, name, options, resolve, reject }: IUpdateButtonOptionsParam) {
    try {
        yield call(Api.updateButtonOptions, projectId, id, name, options);
        const updatedOptions = yield getButtonOptions({ projectId });
        resolve({
            options: updatedOptions
        });
    } catch (error) {
        reject();
        yield errorSaga.putError(error);
    }
}

interface IDeleteButtonOptionsParam extends IPromiseParam {
    projectId: string;
    id: string;
}

export function* deleteButtonOptions({ projectId, id, resolve, reject }: IDeleteButtonOptionsParam) {
    try {
        yield call(Api.deleteButtonOptions, projectId, id);
        const updatedOptions = yield getButtonOptions({ projectId });
        resolve(updatedOptions);
    } catch (error) {
        reject();
        yield errorSaga.putError(error);
    }
}

